import FileUpload from '../../../views/FileUpload.vue'
import UploadOTA from '../../../views/UploadOTA.vue'
import DeviceList from '../../../views/DeviceList.vue'
import GetLogFile from '../../../views/GetLogFile.vue'
import ScreenShot from '../../../views/ScreenShot.vue'
import AlarmList from '../../../views/AlarmList.vue'
import CheckProperties from '../../../views/CheckProperties.vue'
import Suspend from '../../../views/Suspend.vue'
import HardwareControl from '../../../views/HardwareControl.vue'
import { createAppRouter } from '../../../router/createRouter'

export const supervisoryRoutes = [
  {
    path: '/CheckProperties',
    name: 'CheckProperties',
    component: CheckProperties,
    meta: { requiresAuth: true }
  },
  {
    path: '/HardwareControl',
    name: 'HardwareControl',
    component: HardwareControl,
    meta: { requiresAuth: true }
  },
  {
    path: '/ScreenShot',
    name: 'ScreenShot',
    component: ScreenShot,
    meta: { requiresAuth: true }
  },
  {
    path: '/AlarmList',
    name: 'AlarmList',
    component: AlarmList,
    meta: { requiresAuth: true }
  },
  {
    path: '/DeviceList',
    name: 'DeviceList',
    component: DeviceList,
    meta: { requiresAuth: true }
  },
  {
    path: '/FileUpload',
    name: 'FileUpload',
    component: FileUpload,
    meta: { requiresAuth: true }
  },
  {
    path: '/UploadOTA',
    name: 'UploadOTA',
    component: UploadOTA,
    meta: { requiresAuth: true }
  },
  {
    path: '/GetLogFile',
    name: 'GetLogFile',
    component: GetLogFile,
    meta: { requiresAuth: true }
  },
  {
    path: '/Suspend',
    name: 'Suspend',
    component: Suspend,
    meta: { requiresAuth: true }
  }
]

const router = createAppRouter({
  productRoutes: supervisoryRoutes,
  defaultAuthenticatedRoute: '/DeviceList'
})

export default router
